import "core-js/modules/es.array.map.js";
import React from 'react';
import { Inner, RowBlock, Column, HeaderColumn, CellWithIcon } from './partials';
var COMPONENTS = {
  CellWithIcon: CellWithIcon,
  Column: Column,
  HeaderColumn: HeaderColumn
};
export var TableList = function TableList(props) {
  var rows = props.rows,
    lastIsSummary = props.lastIsSummary;
  return React.createElement(Inner, null, rows.map(function (row, rowIndex) {
    var isLastRow = rowIndex === rows.length - (lastIsSummary ? 2 : 1);
    return React.createElement(RowBlock, {
      key: rowIndex,
      lastIsSummary: lastIsSummary,
      isLastRow: isLastRow
    }, row.cells.map(function (cell, cellIndex) {
      var Component = COMPONENTS[cell.params.type] || (cellIndex === 0 ? HeaderColumn : Column);
      var isLast = row.cells.length - 1 === cellIndex && row.cells.length > 1;
      var _ref = cell.params || {},
        _ref$textAlign = _ref.textAlign,
        textAlign = _ref$textAlign === void 0 ? isLast ? 'right' : 'left' : _ref$textAlign;
      return React.createElement(Component, {
        textAlign: textAlign,
        key: cellIndex
      }, cell.component);
    }));
  }));
};